require('./angular-messages');
module.exports = 'ngMessages';



//////////////////
// WEBPACK FOOTER
// ../~/angular-messages/index.js
// module id = 12
// module chunks = 0